import Container from "../components/core/Container"
import Nav from "../components/Nav"
import Heading from "../components/core/Heading"
import Paragraph from "../components/core/Paragraph"
import SectionTag from "../components/core/SectionTag"
import SEO from "../components/SEO"

export default function PodminkyZpracovaniPage() {
  return (
    <>
      <SEO
        title="Zásady zpracování osobních údajů - digibezstresu"
        description="Seznamte se s našimi zásadami zpracování osobních údajů v souladu s GDPR. Informace o tom, jak zpracováváme vaše osobní údaje."
        keywords="GDPR, ochrana osobních údajů, zásady zpracování, soukromí"
        url="/podminky_zpracovani"
      />
      <Container className="min-h-screen flex flex-col">
        <Nav />
      <Container className="mt-8 mb-8" bgColor="transparent" />

      <Container
        className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pb-16"
        bgColor="transparent"
      >
        <SectionTag>Seznámení se zásadami zpracování osobních údajů</SectionTag>

        <Container className="pb-6 border-b border-gray-300 mb-6" bgColor="transparent">
          <Paragraph variant="lead_black">
            Tímto Vás informuji o zpracování osobních údajů v souladu s nařízením Evropského parlamentu a Rady (EU)
            2016/679 (GDPR).
          </Paragraph>
        </Container>

        <Container className="mb-6" bgColor="transparent">
          <Heading variant="h2">1. Správce osobních údajů</Heading>
          <Paragraph>Správcem osobních údajů je:</Paragraph>

          <Container className="bg-gray-50 border border-gray-300 rounded-xl p-4 mt-5" bgColor="gray-50">
            <Paragraph>
                <strong>[Mgr. Danuše Kubová]</strong><br />
                Sídlo / místo podnikání: <strong>[Velichov 163, 363 01 Ostrov]</strong><br />
                IČO: <strong>[75868822]</strong><br />
                E-mail: <strong>[kubova@digibezstresu.cz]</strong>
            </Paragraph>
          </Container>

          <Paragraph variant="small" className="mt-2">
            (dále jen „Správce“)
          </Paragraph>
        </Container>

        <Container className="mb-6" bgColor="transparent">
          <Heading variant="h2">2. Jaké osobní údaje zpracovávám</Heading>
          <Paragraph>
            V souvislosti s používáním webu, kontaktního formuláře, přihlášením na vzdělávací akce a související
            komunikací zpracovávám pouze nezbytné osobní údaje, zejména:
          </Paragraph>

          <ul className="mt-2 ml-6 list-disc space-y-1">
            <li>jméno a příjmení</li>
            <li>datum narození (kvůli vystavení potvrzení o účasti)</li>
            <li>e-mailovou adresu</li>
            <li>telefonní číslo (pokud je uvedeno)</li>
            <li>fakturační údaje (adresa, IČ, DIČ), pokud jsou potřeba pro vystavení dokladu</li>
            <li>informace související s objednávkou / registrací na vzdělávací akci</li>
            <li>obsah zprávy odeslané přes formulář nebo e-mail</li>
            <li>technické údaje: IP adresa, datum a čas odeslání (pro bezpečnost a prevenci zneužití)</li>
            <li>u odběru newsletteru: IP adresa a čas udělení souhlasu (pro prokázání souhlasu)</li>
            <li>
              u přihlášky na vybrané <strong>bezplatné nebo zvýhodněné (promo)</strong> vzdělávací akce, u nichž je
              odběr newsletteru součástí nabídky: e-mailová adresa a údaje související s konkrétní akcí (název kurzu,
              termín apod.), včetně evidence v systému pro zasílání newsletteru po udělení souhlasu
            </li>
          </ul>

          <Paragraph className="mt-4">Nezpracovávám žádné zvláštní (citlivé) osobní údaje.</Paragraph>
        </Container>

        <Container className="mb-6" bgColor="transparent">
          <Heading variant="h2">3. Účel zpracování osobních údajů</Heading>
          <Paragraph>Osobní údaje zpracovávám výhradně za účelem:</Paragraph>

          <ul className="mt-2 ml-6 list-disc space-y-1">
            <li>odpovědi na dotazy odeslané přes kontaktní formulář nebo e-mail</li>
            <li>přihlášení a evidence účastníků vzdělávacích akcí</li>
            <li>komunikace související s účastí na vzdělávací akci nebo poskytnutím služby</li>
            <li>
              zasílání newsletteru s přehledem nabízených kurzů a vzdělávacích akcí (na základě souhlasu), včetně
              případů, kdy je tento souhlas spojen s přihláškou na bezplatnou nebo promo akci podle části 8
            </li>
            <li>vystavení a evidence účetních a daňových dokladů</li>
            <li>splnění zákonných povinností Správce</li>
            <li>zajištění bezpečnosti webu a ochrany proti spamu a zneužití formulářů</li>
          </ul>
        </Container>

        <Container className="mb-6" bgColor="transparent">
          <Heading variant="h2">4. Právní základ zpracování</Heading>
          <Paragraph>Zpracování osobních údajů je nezbytné pro:</Paragraph>

          <ul className="mt-2 ml-6 list-disc space-y-1">
            <li>
              <strong>plnění smlouvy</strong> (přihlášení na vzdělávací akci, objednávka služby, vyřízení požadavku)
            </li>
            <li>
              <strong>splnění právních povinností</strong> Správce (zejména účetní a daňové předpisy)
            </li>
            <li>
              <strong>oprávněný zájem Správce</strong> (odpověď na dotaz, ochrana proti spamu/zneužití, zabezpečení webu)
            </li>
          </ul>

          <Paragraph className="mt-4">
            Souhlas se zpracováním osobních údajů <strong>není vyžadován</strong>, pokud mě kontaktujete nebo si
            objednáváte běžné placené služby bez marketingového odběru. Pokud by byl v konkrétním případě souhlas potřeba
            (např. zasílání newsletteru nebo kombinovaná přihláška podle části 8), vyžádám si jej zřetelně ve formuláři
            nebo jiným prokazatelným způsobem.
          </Paragraph>
        </Container>

        <Container className="mb-6" bgColor="transparent">
          <Heading variant="h2">5. Doba uchování osobních údajů</Heading>
          <Paragraph>Osobní údaje jsou uchovávány:</Paragraph>

          <ul className="mt-2 ml-6 list-disc space-y-1">
            <li>po dobu trvání komunikace nebo smluvního vztahu</li>
            <li>
              následně po dobu stanovenou platnými právními předpisy, zejména zákonem o účetnictví (obvykle{" "}
              <strong>10 let</strong>)
            </li>
            <li>údaje z kontaktních formulářů typicky nejdéle <strong>12 měsíců</strong>, pokud z nich nevznikne smluvní vztah</li>
            <li>údaje u newsletteru po dobu trvání odběru, po odhlášení bez zbytečného odkladu v souladu s bodem 8</li>
          </ul>

          <Paragraph className="mt-4">Po uplynutí této doby jsou údaje bezpečně odstraněny nebo anonymizovány.</Paragraph>
        </Container>

        <Container className="mb-6" bgColor="transparent">
          <Heading variant="h2">6. Příjemci osobních údajů (zpracovatelé)</Heading>
          <Paragraph>Osobní údaje mohou být zpřístupněny pouze v nezbytném rozsahu těmto příjemcům:</Paragraph>

          <ul className="mt-2 ml-6 list-disc space-y-1">
            <li>účetní nebo daňové kanceláři (pokud je využívána)</li>
            <li>poskytovatelům IT a webhostingových služeb</li>
            <li>poskytovateli e-mailové infrastruktury pro odeslání zpráv</li>
          </ul>

          <Container className="bg-gray-50 border border-gray-300 rounded-xl p-4 mt-5" bgColor="gray-50">
            <Paragraph>
              Konkrétně využívám tyto služby:
              <br />
              <strong>Vercel Inc.</strong> – provoz webu a serverových funkcí (hosting)
              <br />
              <strong>Resend, Inc.</strong> – odesílání e-mailů (transakční komunikace, odpovědi z formuláře a zasílání newsletteru)
            </Paragraph>
          </Container>

          <Paragraph className="mt-4">
            Tyto služby mohou zpracovávat osobní údaje i mimo Evropskou unii (zejména v USA). Přenos je realizován na
            základě vhodných záruk dle GDPR (typicky <strong>Standardní smluvní doložky</strong>).
          </Paragraph>

          <Paragraph className="mt-4">
            Osobní údaje <strong>neprodávám</strong> ani je neposkytuji třetím osobám pro marketingové účely.
          </Paragraph>
        </Container>

        <Container className="mb-6" bgColor="transparent">
          <Heading variant="h2">7. Práva subjektu údajů</Heading>
          <Paragraph>Máte právo:</Paragraph>

          <ul className="mt-2 ml-6 list-disc space-y-1">
            <li>na přístup ke svým osobním údajům</li>
            <li>na jejich opravu nebo doplnění</li>
            <li>na přenositelnost údajů – získat je ve strukturovaném, běžně používaném formátu a předat jinému správci (kde to zákon umožňuje)</li>
            <li>na omezení zpracování</li>
            <li>na výmaz osobních údajů, pokud to není v rozporu s právními povinnostmi Správce</li>
            <li>vznést námitku proti zpracování na základě oprávněného zájmu</li>
            <li>odvolat souhlas kdykoli, pokud je zpracování založeno na souhlasu, aniž by to ovlivnilo zákonnost zpracování před odvoláním</li>
            <li>podat stížnost u Úřadu pro ochranu osobních údajů</li>
          </ul>

          <Paragraph className="mt-4">
            Svá práva můžete uplatnit e-mailem na adrese uvedené v části „Správce osobních údajů“.
          </Paragraph>
        </Container>

        <Container className="mb-6" bgColor="transparent">
          <Heading variant="h2">8. Newsletter a marketingová sdělení</Heading>
          <Paragraph>
            V případě, že se přihlásíte k odběru newsletteru, budete pravidelně dostávat strukturované e-maily s přehledem nabízených kurzů a vzdělávacích akcí.
          </Paragraph>

          <Paragraph className="mt-4">
            <strong>Obsah newsletteru:</strong>
          </Paragraph>
          <ul className="mt-2 ml-6 list-disc space-y-1">
            <li>strukturovaný přehled aktuálně nabízených kurzů</li>
            <li>informace o nových vzdělávacích akcích</li>
            <li>aktuality a zajímavosti z oblasti vzdělávání</li>
          </ul>

          <Paragraph className="mt-4">
            <strong>Právní základ:</strong> Zasílání newsletteru probíhá na základě vašeho <strong>souhlasu</strong>, který udělíte při přihlášení k odběru.
          </Paragraph>

          <Paragraph className="mt-4">
            <strong>Bezplatné a promo akce s podmínkou newsletteru:</strong> U některých bezplatných nebo zvýhodněných
            kurzů a akcí je účast podmíněna zároveň <strong>souhlasem se zařazením do seznamu příjemců newsletteru</strong>{" "}
            (měsíční přehled nabídky a novinek). Přihlášku v takovém případě dokončíte odesláním formuláře na webu, kde
            jsou podmínky uvedeny a kde zvlášť potvrdíte seznámení se zásadami zpracování osobních údajů a souhlas s
            obchodními podmínkami. Jedním krokem tak udělujete souhlas se zpracováním údajů pro účely newsletteru v rozsahu
            popsaném v těchto zásadách a zároveň žádáte o zařazení na konkrétní akci. Pokud newsletterový kontakt u vás
            již existuje, přihláška na akci může být zpracována i bez nového založení duplicitního záznamu; odběr
            newsletteru nadále řídíte odhláškou podle níže uvedených pravidel.
          </Paragraph>

          <Paragraph className="mt-4">
            Pro prokázání vašeho souhlasu eviduji u odběru newsletteru IP adresu a čas přihlášení.
          </Paragraph>

          <Paragraph className="mt-4">
            <strong>Odhlášení z odběru:</strong> Od odběru newsletteru se můžete kdykoli odhlásit následujícími způsoby:
          </Paragraph>
          <ul className="mt-2 ml-6 list-disc space-y-1">
            <li>využitím odkazu pro odhlášení, který je obsažen v každém e-mailu newsletteru</li>
            <li>odesláním e-mailu správci osobních údajů na adrese uvedené v části „Správce osobních údajů“ s požadavkem na ukončení zasílání</li>
          </ul>

          <Paragraph className="mt-4">
            Po odhlášení budou vaše osobní údaje používané pro zasílání newsletteru bez zbytečného odkladu odstraněny, pokud není jejich další zpracování nutné z jiných právních důvodů (např. plnění smluvních podmínek, evidence účasti na již proběhlé akci v nezbytném rozsahu).
          </Paragraph>
        </Container>

        <Container className="mb-6" bgColor="transparent">
          <Heading variant="h2">9. Cookies</Heading>
          <Paragraph>
            Web může používat cookies nezbytné pro jeho fungování. V případě použití dalších cookies (např. analytických) budete informováni a vyžádán váš souhlas před jejich aktivací.
          </Paragraph>
        </Container>

        <Container className="mb-6" bgColor="transparent">
          <Heading variant="h2">10. Závěrečná ustanovení</Heading>
          <Paragraph>
            Tyto zásady jsou platné od <strong>[02.02.2026]</strong>, naposledy doplněny dne{" "}
            <strong>05.04.2026</strong>, a jsou zveřejněny na webových stránkách Správce.
          </Paragraph>
        </Container>

        <Container className="mt-8 pt-4 border-t border-gray-300" bgColor="transparent">
          <Paragraph variant="small">
            Poslední aktualizace: <strong>05.04.2026</strong>
          </Paragraph>
        </Container>
      </Container>
    </Container>
    </>
  )
}
